import {AxiosResponse} from "axios";
import {AxiosConfig} from "./AxiosConfig/AxiosConfig";

const getGraphToken = () => {
    return new Promise<string | null>(resolve => {
        return AxiosConfig.instance.get("/graphtoken").then((response: AxiosResponse) => {
            return resolve(response.data);
        }).catch(_ => {
            return resolve(null);
        });
    });
}

const saveToken = () => {
    return new Promise<void>((resolve, reject) => {
        const url = "/StoreToken";
        return AxiosConfig.instance.get(url).then((response: AxiosResponse) => {
            if (response.status !== 200)
                throw new Error("Can't save token");
            return resolve();
        }).catch(_ => {
            reject("Can't save token");
        })
    })
}

export const TokenApi = {
    saveToken,
    getGraphToken,
}